export type ConsolidateTaxEntry = {
  taxType: string;
  taxAmount: number;
  /**
   * Per-tax-type taxable base for the source invoice
   */
  taxableAmount?: number;
};

export const round2 = (value: number) => Math.round(value * 100) / 100;

/**
 * Split a source invoice's net
 */
export function allocateNetByTaxType(
  entries: ConsolidateTaxEntry[],
  netExcludingTax: number,
): number[] {
  if (entries.length === 0) return [];
  if (entries.length === 1) return [netExcludingTax];

  const baseTotal = entries.reduce(
    (sum, entry) => sum + Number(entry.taxableAmount ?? 0),
    0,
  );

  // No usable per-type bases
  if (!(baseTotal > 0)) {
    return entries.map((_, index) => (index === 0 ? netExcludingTax : 0));
  }

  const allocated = entries.map((entry) =>
    round2((netExcludingTax * Number(entry.taxableAmount ?? 0)) / baseTotal),
  );

  // Push any rounding remainder
  const remainder = round2(
    netExcludingTax - allocated.reduce((sum, value) => sum + value, 0),
  );
  if (remainder !== 0) {
    let largest = 0;
    for (let index = 1; index < allocated.length; index++) {
      if (allocated[index] > allocated[largest]) largest = index;
    }
    allocated[largest] = round2(allocated[largest] + remainder);
  }

  return allocated;
}
